import { useState } from "react";
import DiagnosticFormModal from "./DiagnosticFormModal";

const DiagnosticSection = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <section className="w-full bg-white py-28">
        <div className="max-w-7xl mx-auto px-6">

          {/* TÍTULO */}
          <div className="text-center max-w-4xl mx-auto mb-20">
            <h2 className="text-4xl md:text-5xl font-extrabold text-slate-900">
              Diagnóstico y demo operativa
            </h2>

            <p className="mt-4 text-lg md:text-xl font-medium text-slate-600 whitespace-nowrap">
              Prueba SERGEN durante 30 días y valida si aplica a tu operación
            </p>
          </div>

          {/* CONTENIDO */}
          <div className="grid lg:grid-cols-2 gap-20 items-center">

            {/* TEXTO */}
            <div className="max-w-xl space-y-6">
              <p className="text-xl md:text-2xl font-semibold text-slate-900 leading-snug">
                Te mostramos con datos reales cuánto puedes ahorrar,
                <span className="text-sergen-700 font-bold">
                  {" "}sin tocar tu operación
                </span>.
              </p>

              <p className="text-base md:text-lg text-slate-700 leading-relaxed">
                Analizamos tus facturas eléctricas y detectamos oportunidades de ahorro
                en los{" "}
                <span className="font-semibold text-slate-800">
                  momentos que generan sobrecostos
                </span>.
              </p>

              <p className="text-sm text-slate-500">
                Sin compra de equipos · Sin cambios operativos · Sin compromiso
              </p>

              <div className="pt-6">
                <button
                  onClick={() => setOpen(true)}
                  className="
                    inline-flex
                    items-center
                    justify-center
                    rounded-full
                    bg-sergen-500
                    px-10
                    py-4
                    text-white
                    font-semibold
                    text-base
                    shadow-lg
                    shadow-sergen-500/30
                    hover:bg-sergen-600
                    transition-all
                  "
                >
                  Evaluar mi factura eléctrica
                </button>
              </div>
            </div>

            {/* IMAGEN */}
            <div className="relative flex justify-center lg:justify-end">
              <div className="absolute -z-10 w-[420px] h-[420px] bg-sergen-400/20 blur-3xl rounded-full top-1/2 -translate-y-1/2" />

              <img
                src="/mobile-sergen.png"
                alt="Demo app SERGEN"
                className="
                  w-[460px]
                  md:w-[520px]
                  lg:w-[560px]
                  drop-shadow-2xl
                  transition-transform
                  duration-300
                  hover:scale-[1.02]
                "
              />
            </div>

          </div>
        </div>
      </section>

      {/* MODAL */}
      <DiagnosticFormModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default DiagnosticSection;
